import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ApplicationDispatcher {
  public onColumnHeaderGrouped: Subject<any> = new Subject<any>();
}
